import { Text } from '@amzn/meridian';
import moment from 'moment';
import { type FC, useEffect, useState } from 'react';
import { colors } from 'resources/tokens';
import { classes, stylesheet } from 'typestyle';
import { SidebarButton } from './SidebarButton';

export type SaveButtonProps = {
  disabled?: boolean;
  label: string;
  lastSavedTime?: string;
  onClick: () => void;
  title?: string;
};

const css = stylesheet({
  displayNone: {
    display: 'none',
  },
  lastSaved: {
    color: colors.textSecondary,
    cursor: 'pointer',
    fontSize: 'smaller',
    textDecoration: 'underline',
    textDecorationStyle: 'dashed',
    textUnderlinePosition: 'under',
  },
});

export const SaveButton: FC<SaveButtonProps> = ({ onClick, lastSavedTime, disabled = false, title, label }) => {
  const [lastSavedTimeRelative, setLastSavedTimeRelative] = useState('');
  const [isDisplayed, setIsDisplayed] = useState(true);
  const [lastSavedUtc] = useState(moment.utc(lastSavedTime).format('YYYY-MM-DD HH:mm:ss UTC'));

  function toggleDisplay() {
    setIsDisplayed(!isDisplayed);
  }

  useEffect(() => {
    function getLastSavedTimeRelative() {
      setLastSavedTimeRelative(lastSavedTime ? moment(lastSavedTime).fromNow() : '');
    }

    const ms = 5000;
    getLastSavedTimeRelative();
    const interval = setInterval(() => getLastSavedTimeRelative(), ms);
    return () => clearInterval(interval);
  }, [
    lastSavedTime,
  ]);

  return (
    <div className="save-controls pod-menu-item">
      <SidebarButton
        className="btn btn-sidebar w-100 text-left"
        data-cy="save-btn"
        disabled={disabled}
        icon="fa-save"
        label={label}
        onClick={onClick}
        padBottom={false}
        title={title}
      />
      {lastSavedTimeRelative && (
        <div className={classes(css.lastSaved)} data-cy="last-saved" onClick={toggleDisplay}>
          <Text className={classes(!isDisplayed && css.displayNone)} color="secondary" id="last-save-time-relative" tag="span" type="b100">
            Saved {lastSavedTimeRelative}
          </Text>
          <Text className={classes(isDisplayed && css.displayNone)} color="secondary" id="last-save-time-utc" tag="span" type="b100">
            Saved at {lastSavedUtc}
          </Text>
        </div>
      )}
    </div>
  );
};
